import { q } from '../helper/q'

export const teamInit = () => {
  const button = q('.aboutTeamMore')
  const block = q('.aboutTeamItemsExpand')
  if (!button) return null
  button.addEventListener('click', () => {
    block.classList.toggle('aboutTeamItemsExpandShow')
    button.style.display = 'none'
  })
}
